import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import { AiOutlineDelete, AiOutlineSearch } from "react-icons/ai";
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { addminPromoCodeList, addminCheckoutPromoCodeList } from '../../../../../redux/actions/admin';
import { SearchWrapper, SelectWrapper } from '../DashBoard/dashBoardStyled'
import CsvDownloader from 'react-csv-downloader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AlertModal from 'web/components/AlertModal';

import CreatePromoCode from './CreatePromoCode';
import UsersList from './UsersList';
import UsersPromoCodeList from './UsersPromoCodeList';
import AddPromoCodeforUser from './AddPromoCodeforUser';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import styled from 'styled-components';
import UserListCheckoutPromo from './UserListCheckoutPromo';

function PromoCode() {
    const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
    let dispatch = useDispatch()
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [promoCodeType, setPromoCodeType] = useState('Registration')
    const [activePage, setActivePage] = useState('PromoCode')

    //data of registration promos
    const [dataList, setDataList] = useState([])
    const [finalData, setFinalData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [searchDataList, setSearchDataList] = useState([]);
    const [csvData, setCsvData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [promoUsersList, setPromoUsersList] = useState([]) //state where clicked promocode's users list (from first to second page)
    const [usersPromoCodeList, setUsersPromoCodeList] = useState([]) // state where clicked users promocode list is stored (from second to third page)
    const [tableData, setTableData] = useState([]) // state where clicked promocode's details are stored (for header details second page)
    const [promoUsersTableData, setPromoUsersTableData] = useState([]) // state where clicked promocode user's details are stored (for header details third page)
    //data of checkout promos    
    const [dataListCheckout, setDataListCheckout] = useState([])
    const [finalDataCheckout, setFinalDataCheckout] = useState([])
    const [searchDataListCheckout, setSearchDataListCheckout] = useState([]);
    const [csvDataCheckout, setCsvDataCheckout] = useState([])
    const [pageCheckout, setPageCheckout] = useState(1);
    const [pageCountCheckout, setPageCountCheckout] = useState(0);
    const [tableSearchCheckout, setTableSearchCheckout] = useState('')
    const [promoUsersListCheckout, setPromoUsersListCheckout] = useState([]) //state where clicked promocode's users list (from first to second page)
    const [tableDataCheckout, setTableDataCheckout] = useState([]) // state where clicked promocode's details are stored (for header details second page)

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const toggleModal = () => {
        if (promoCodeType === 'Registration') fetchMyAPI()
        else fetchCheckoutPromoAPI()
        setModal(!modal);
    }

    const switchActivePage = (value) => {
        setActivePage(value)
    }

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        if (promoCodeType === 'Registration') fetchMyAPI()
        else fetchCheckoutPromoAPI()
    }, [promoCodeType]);

    // fetch registration promocode list 
    const fetchMyAPI = async () => {
        setPromoCodeType('Registration')
        let response = '';
        response = await dispatch(addminPromoCodeList());
        if (response.data && response.data.status === 'SUCCESS') {
            if (response.data.payload.length !== 0) {
                let adminPromoCodeListTemp = response.data.payload.reverse()
                let adminPromoCodeList = adminPromoCodeListTemp.map(data => {
                    return {
                        ...data,
                        state: data.isActive ? 'Active' : 'Inactive',
                    }
                })
                //set data for csv export
                setCSVDate(adminPromoCodeList)

                setDataList(adminPromoCodeList)
                setSearchDataList(adminPromoCodeList)
                let pageData = JSON.parse(JSON.stringify(adminPromoCodeList))
                setFinalData(pageData.splice(page * 10 - 10, 10))
                if (adminPromoCodeList.length % 10 === 0) {
                    setPageCount(adminPromoCodeList.length / 10)
                } else {
                    setPageCount(Math.trunc(adminPromoCodeList.length / 10) + 1)
                }
                setTableSearch('')

                //updating table data for userlist page
                let forUserList = JSON.parse(JSON.stringify(adminPromoCodeList))
                const promocodeId = localStorage.getItem("selectedPromoCodeId")
                if (promocodeId !== null && forUserList.length > 0) {
                    let tableDataTemp = forUserList.filter(data => data.id === promocodeId)
                    setTableData(tableDataTemp)
                    fetchListOfUsers(promocodeId, 'fromFetchAPI')
                }
            }
        } else {
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.data?.message || response.message || 'Something went wrong, please try after sometime.')
                setModal(!modal)
            }
        }
    };

    // fetch checkout promocode list 
    const fetchCheckoutPromoAPI = async () => {
        setPromoCodeType('Checkout')
        let response = '';
        response = await dispatch(addminCheckoutPromoCodeList());
        if (response.data) {
            if (response.data?.length !== 0) {
                let adminPromoCodeListTemp = response.data?.reverse()
                //set data for csv export
                setCSVDateCheckoutPromos(adminPromoCodeListTemp)

                setDataListCheckout(adminPromoCodeListTemp)
                setSearchDataListCheckout(adminPromoCodeListTemp)
                let pageData = JSON.parse(JSON.stringify(adminPromoCodeListTemp))
                setFinalDataCheckout(pageData.splice(page * 10 - 10, 10))
                if (adminPromoCodeListTemp.length % 10 === 0) {
                    setPageCountCheckout(adminPromoCodeListTemp.length / 10)
                } else {
                    setPageCountCheckout(Math.trunc(adminPromoCodeListTemp.length / 10) + 1)
                }
                setTableSearchCheckout('')
            }
        } else {
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.data?.message || response.message || 'Something went wrong, please try after sometime.')
                setModal(!modal)
            }
        }
    };

    // header for registration promo
    let headerArr = [
        { title: 'Promo Code', },
        { title: 'Status ', },
        { title: 'Start Date', },
        { title: 'Expiry Date', },
        { title: 'Benefit Duration', },
        { title: 'Description', },
        { title: 'Used Count', },
        { title: 'Actions', }
    ];

    // header for checkout promo 
    let headerArrCheckoutPromos = [
        { title: 'Promo Code', },
        { title: 'Discount Type ', },
        { title: 'Discount Value', },
        { title: 'Min. Value', },
        { title: 'Max. Value', },
        { title: 'Start Date', },
        { title: 'End Date', },
        { title: 'Description', },
        { title: 'Used Count', },
        { title: 'Status', }
    ];

    //for csv download regis promos
    const columns = [
        { id: 'PromoCode', displayName: 'Promo Code' },
        { id: 'Status', displayName: 'Status' },
        { id: 'StartDate', displayName: 'Start Date' },
        { id: 'ExpiryDate', displayName: 'Expiry Date' },
        { id: 'BenefitDuration', displayName: 'Benefit Duration' },
        { id: 'Description', displayName: 'Description' },
        { id: 'UsedCount', displayName: 'Used Count' },
    ]

    //for csv download checkout promos
    const columnsCheckoutPromos = [
        { id: 'PromoCode', displayName: 'Promo Code' },
        { id: 'DiscountType', displayName: 'Discount Type ' },
        { id: 'DiscountValue', displayName: 'Discount Value' },
        { id: 'MinValue', displayName: 'Min. Value' },
        { id: 'MaxValue', displayName: 'Max. Value' },
        { id: 'StartDate', displayName: 'Start Date' },
        { id: 'ExpDate', displayName: 'End Date' },
        { id: 'Description', displayName: 'Description' },
        { id: 'UsedCount', displayName: 'Used Count' },
        { id: 'Status', displayName: 'Status' },
    ]

    // set csv date for registration promos
    const setCSVDate = (dataList) => {
        let tempCsvData = dataList.map(items => {
            let benDuration = items.timeSpanForBenefits && items.timeSpanForBenefits.number && items.timeSpanForBenefits.number?.toString()
            let benType
            if (items.timeSpanForBenefits && items.timeSpanForBenefits.number && items.timeSpanForBenefits.number > 1)
                benType = items.timeSpanForBenefits && items.timeSpanForBenefits.timeDMY && ` ${items.timeSpanForBenefits.timeDMY}s`
            else benType = items.timeSpanForBenefits && items.timeSpanForBenefits.timeDMY && ` ${items.timeSpanForBenefits.timeDMY}`
            return ({
                PromoCode: items.promoCode?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                Status: items.state,
                StartDate: items.applyStartDate ? moment(items.applyStartDate).format("MM/DD/YYYY") : '',
                ExpiryDate: items.applyEndDate ? moment(items.applyEndDate).format("MM/DD/YYYY") : '',
                BenefitDuration: benDuration + benType,
                Description: items.description?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                UsedCount: items.usedCount,
            })
        })
        setCsvData(tempCsvData.flat())
    }

    // set csv date for checkout promos
    const setCSVDateCheckoutPromos = (dataList) => {
        let tempCsvData = dataList.map(items => {
            return ({
                PromoCode: items.promoCode?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                DiscountType: items.discountType,
                DiscountValue: items.discountValue,
                MinValue: items.minTransValue,
                MaxValue: items.maxTransValue ? items.maxTransValue : 'NA',
                StartDate: items.startDate ? moment(items.startDate).format("MM/DD/YYYY") : '',
                ExpDate: items.expDate ? moment(items.expDate).format("MM/DD/YYYY") : '',
                Description: items.description?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                UsedCount: items.usedCount,
                Status: items.active ? 'Active' : 'Inactive'
            })
        })
        setCsvDataCheckout(tempCsvData.flat())
    }

    // page change function for registration promo list
    const handleChange = (event, value) => {
        setPage(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchDataList))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    // page change function for checkout promo list
    const handleChangeCheckout = (event, value) => {
        setPageCheckout(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchDataListCheckout))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalDataCheckout(pageData.splice(value * 10 - 10, 10))
    };

    // for registration promo for search function
    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.promoCode !== null && value.promoCode.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.description !== null && value.description.toString().toLowerCase().includes(search.toLowerCase()))
                // (value.startDate !== null && value.startDate.toString().toLowerCase().includes(search.toLowerCase())) ||
                // (value.expireDate !== null && value.expireDate.toString().toLowerCase().includes(search.toLowerCase())) ||
                // (value.discountType !== null && value.discountType.toString().toLowerCase().includes(search.toLowerCase())) ||
                // (value.customerEligibility !== null && value.customerEligibility.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPage(1)
        setCSVDate(dataListtemp)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        let tempSearchData = JSON.parse(JSON.stringify(dataListtemp))
        setSearchDataList(tempSearchData)
        setFinalData(dataListtemp.splice(0, 10))
    }

    // for checkout promo for search function
    const handleSearchChangeCheckout = e => {
        e.preventDefault()
        setTableSearchCheckout(e.target.value)
        const search = e.target.value
        let dataListtemp = dataListCheckout.filter(value => {
            return (
                (value.promoCode !== null && value.promoCode.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.description !== null && value.description.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.discountType !== null && value.discountType.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPageCheckout(1)
        setCSVDateCheckoutPromos(dataListtemp)
        if (dataListtemp.length % 10 === 0) {
            setPageCountCheckout(dataListtemp.length / 10)
        } else {
            setPageCountCheckout(Math.trunc(dataListtemp.length / 10) + 1)
        }
        let tempSearchData = JSON.parse(JSON.stringify(dataListtemp))
        setSearchDataListCheckout(tempSearchData)
        setFinalDataCheckout(dataListtemp.splice(0, 10))
    }

    // if delete is confirmed, this function is called (for registration promo)
    const handleDeleteConfirmation = () => {
        setDeleteConfirmationModal(!deleteConfirmationModal);
        const token = localStorage.getItem("token")
        const id = localStorage.getItem('promoDeleteIndex')
        localStorage.removeItem('promoDeleteIndex')
        axioPath.get(`/user/promocode/${id}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            setModal(!modal)
            setModalContent('Promo code has been deleted.')
        }).catch((ex) => {
            setModal(!modal)
            setModalContent(ex.message)
        });
    }

    // while clicking delete icon (registration promo), this func is called for popping confirmation modal
    const handleDelete = (e, index) => {
        e.preventDefault()
        localStorage.setItem('promoDeleteIndex', finalData[index].id)
        setDeleteConfirmationModal(!deleteConfirmationModal);
    }

    //click a promocode to see the list of users (registration)
    const handleIdClick = (e, index) => {
        e.preventDefault()
        localStorage.setItem("selectedPromoIndex", index)
        localStorage.setItem("selectedPromoCodeId", finalData[index].id)
        let promocodeId = finalData[index].id
        fetchListOfUsers(promocodeId)
    }

    //click a promocode to see the list of users (checkout)
    const handleIdClickCheckout = (e, index) => {
        e.preventDefault()
        let promocodeId = finalDataCheckout[index].id
        fetchListOfUsersCheckout(promocodeId)
    }

    // function for fetching the list of users of a particular promocode (registration promocode)
    const fetchListOfUsers = (promocodeId, type) => {
        const token = localStorage.getItem("token")
        axioPath.get(`/user/newPromoCode/${promocodeId}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data && response.data.status !== 'FAILURE') {
                if (type === 'fromFetchAPI') {
                    setPromoUsersList(response.data)
                } else {
                    setPromoUsersList(response.data)
                    let tableDataTemp = finalData.filter(data => data.id === promocodeId)
                    setTableData(tableDataTemp)
                    switchActivePage('UsersList')
                }
            } else {
                setModalContent(response.data.message)
                setModal(!modal)
            }
        }).catch((ex) => {
            setModalContent(ex.message)
            setModal(!modal)
        });
    }

    // function for fetching the list of users of a particular promocode (checkout promocode)
    const fetchListOfUsersCheckout = (promocodeId) => {
        const token = localStorage.getItem("token")
        axioPath.get(`/user/newPromoCode/checkout_promoused_list/${promocodeId}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data && response?.status === 200) {
                setPromoUsersListCheckout(response.data)
                let tableDataTemp = finalDataCheckout.filter(data => data.id === promocodeId)
                setTableDataCheckout(tableDataTemp)
                switchActivePage('UsersListCheckoutPromo')
            } else if (response.data === '' || response.data?.length === 0) {
                setPromoUsersListCheckout([])
                let tableDataTemp = finalDataCheckout.filter(data => data.id === promocodeId)
                setTableDataCheckout(tableDataTemp)
                switchActivePage('UsersListCheckoutPromo')
            } else {
                setModalContent(response.data?.message || response.message || 'Something went wrong, please try again after sometime.')
                setModal(!modal)
            }
        }).catch((ex) => {
            setModalContent(ex.message)
            setModal(!modal)
        });
    }

    //this method is used for updating the promocode list of specific users
    const updateUsersPromoCodeList = (data) => {
        setUsersPromoCodeList(data)
    }

    //updating header data of users promocode list page
    const updateUsersPromoCodeTableData = (data, page) => {
        setPromoUsersTableData([data])
    }

    // adding existing promocode to a user from final page by choosing a existing promocode
    const updateNewPromoCodeListforUser = (user) => {
        const token = localStorage.getItem("token")
        axioPath.get(`/user/newPromoCode/userName/${user}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data) {
                updateUsersPromoCodeList(response.data)
            }
            switchActivePage('UsersPromoCodeList')
        }).catch((ex) => {
            setModalContent(ex.message)
            setModal(!modal)
        });
    }

    // adding existing promocode to a user from promo user list page by choosing a user name
    const updateNewPromoCodeListforUserFromUsersListPage = (userId) => {
        fetchListOfUsers(userId)
    }

    // from promo code users list page, promo code activity status is tooggled using this function (registration promocode)
    const updatePromoCodeStatus = (promoCodeId, promoStatus, token) => {
        const status = promoStatus === "Active" ? false : true
        axioPath.post(`/user/newPromoCode/updatePromoCodesStatus?status=${status}&promoCodeId=${promoCodeId}`, {}, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data && response.data.status !== 'FAILURE') {
                setModalContent(!status ? 'Promo code deactivated successfully.' : 'Promo code activated successfully.')
                setModal(!modal)
                fetchMyAPI()
                setPromoUsersList(promoUsersList)
            } else {
                setModalContent(response.data.message)
                setModal(!modal)
            }
        }).catch((ex) => {
            setModalContent(ex.message)
            setModal(!modal)
        });
    }

    // from promo code users list page, promo code activity status is tooggled using this function (checkout promocode)
    const updateCheckoutPromoCodeStatus = (promoCodeId, promoStatus) => {
        const token = localStorage.getItem("token")
        axioPath.get(`user/newPromoCode/active/${promoCodeId}/${!promoStatus}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data?.status === 'SUCCESS') {
                setModalContent(!promoStatus ? 'Promo code activated successfully.' : 'Promo code deactivated successfully.')
                setModal(!modal)
                fetchCheckoutPromoAPI()
            } else {
                setModalContent(response.data?.message || 'Something went wrong, please try again after sometime.')
                setModal(!modal)
            }
        }).catch((ex) => {
            setModalContent(ex.message)
            setModal(!modal)
        });
    }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PROMO_CODE'))) ?

                <>
                    {activePage === 'PromoCode' &&
                        <TableWrapper>
                            {loaderVisible && <Spinner />}
                            <Heading>
                                <div className='promo-head-section'>
                                    <h3>Promo Code</h3>
                                    <select className='promo-heading-select-style' id='promoCodeType' value={promoCodeType}
                                        onChange={(e) => setPromoCodeType(e.target.value)}>
                                        <option value='Registration'>Registration Promo Codes</option>
                                        <option value='Checkout'>Checkout Promo Codes</option>
                                    </select>
                                </div>
                                <RightSection>

                                    <SearchWrapper>
                                        {promoCodeType === 'Registration' ?
                                            <input type="text" placeholder='Search' value={tableSearch}
                                                onChange={handleSearchChange} />
                                            :
                                            <input type="text" placeholder='Search' value={tableSearchCheckout}
                                                onChange={handleSearchChangeCheckout} />
                                        }
                                        <AiOutlineSearch />
                                    </SearchWrapper>
                                    <button
                                        style={buttonStyle}
                                        onClick={e => switchActivePage('CreatePromoCode')}
                                    >Create New Code
                                    </button>
                                    {promoCodeType === 'Registration' ?
                                        <CsvDownloader
                                            filename="Promo Code List"
                                            columns={columns}
                                            datas={csvData}>
                                            <button
                                                style={buttonStyle}>
                                                Export
                                            </button>
                                        </CsvDownloader>
                                        :
                                        <CsvDownloader
                                            filename="Promo Code List"
                                            columns={columnsCheckoutPromos}
                                            datas={csvDataCheckout}>
                                            <button
                                                style={buttonStyle}>
                                                Export
                                            </button>
                                        </CsvDownloader>
                                    }
                                </RightSection>
                            </Heading>

                            {promoCodeType === 'Registration' ?
                                <>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                {headerArr.map((items, index) => (
                                                    <th key={index}>{items.title}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                finalData.map((items, index) => (
                                                    <tr key={index}>
                                                        <td><a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                                            onClick={e => handleIdClick(e, index)}
                                                        >{items.promoCode}</a></td>
                                                        <td>{items.state}</td>
                                                        <td>{items.applyStartDate ? moment(items.applyStartDate).format("MM/DD/YYYY") : ''}</td>
                                                        <td>{items.applyEndDate ? moment(items.applyEndDate).format("MM/DD/YYYY") : ''}</td>
                                                        <td>{items.timeSpanForBenefits && items.timeSpanForBenefits.number && items.timeSpanForBenefits.number}
                                                            &nbsp;
                                                            {items.timeSpanForBenefits && items.timeSpanForBenefits.number && items.timeSpanForBenefits.number > 1 ?
                                                                items.timeSpanForBenefits && items.timeSpanForBenefits.timeDMY && `${items.timeSpanForBenefits.timeDMY}s` :
                                                                items.timeSpanForBenefits && items.timeSpanForBenefits.timeDMY && items.timeSpanForBenefits.timeDMY}
                                                        </td>
                                                        <td style={{ wordBreak: 'break-all', maxWidth: '150px' }} title={items.description}>{items.description?.substring(0, 30)}{items.description?.length > 30 && <span>...</span>}</td>
                                                        <td>{items.usedCount}</td>
                                                        <td>
                                                            <AiOutlineDelete
                                                                title='Delete Promo Code'
                                                                onClick={(e) => {
                                                                    handleDelete(e, index)
                                                                }} style={{ margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer' }} />
                                                        </td>

                                                    </tr>
                                                ))}
                                        </tbody>
                                    </Table>
                                    {finalData.length === 0 && !loaderVisible &&
                                        <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
                                    }
                                    {finalData.length != 0 && dataList.length !== 0 && <Pagination count={pageCount}
                                        page={page}
                                        onChange={handleChange} />}
                                </>
                                :
                                <>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                {headerArrCheckoutPromos.map((items, index) => (
                                                    <th key={index}>{items.title}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                finalDataCheckout.map((items, index) => (
                                                    <tr key={index}>
                                                        <td><a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                                            onClick={e => handleIdClickCheckout(e, index)}
                                                        >{items.promoCode}</a></td>
                                                        <td>{items.discountType}</td>
                                                        <td>{items.discountType === 'FLAT' && '$'} {items.discountValue}{items.discountType === 'PERCENTAGE' && '%'}</td>
                                                        <td>$ {items.minTransValue}</td>
                                                        <td>{items.maxTransValue ? `$ ${items.maxTransValue}` : 'NA'}</td>
                                                        <td>{items.startDate ? moment(items.startDate).format("MM/DD/YYYY") : ''}</td>
                                                        <td>{items.expDate ? moment(items.expDate).format("MM/DD/YYYY") : ''}</td>
                                                        <td style={{ wordBreak: 'break-all', maxWidth: '150px' }} title={items.description}>{items.description?.substring(0, 30)}{items.description?.length > 30 && <span>...</span>}</td>
                                                        <td>{items.usedCount}</td>
                                                        <td className='toggle-button-style'>
                                                            <FormControlLabel
                                                                style={{ marginRight: 0 }}
                                                                labelPlacement="right"
                                                                label={items.active ? 'Active' : 'Inactive'}
                                                                control={
                                                                    <Switch
                                                                        checked={items.active}
                                                                        onClick={() => updateCheckoutPromoCodeStatus(items.id, items.active)}
                                                                        name="checkedB"
                                                                        color="primary"
                                                                    />
                                                                }
                                                            /></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </Table>
                                    {finalDataCheckout.length === 0 && !loaderVisible &&
                                        <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
                                    }
                                    {finalDataCheckout.length != 0 && dataList.length !== 0 && <Pagination count={pageCountCheckout}
                                        page={pageCheckout}
                                        onChange={handleChangeCheckout} />}
                                </>
                            }
                        </TableWrapper>
                    }

                    {activePage === 'CreatePromoCode' && <CreatePromoCode togglePage={switchActivePage} fetchMyAPI={fetchMyAPI} fetchCheckoutPromoAPI={fetchCheckoutPromoAPI} promoCodeType={promoCodeType} />}
                    {activePage === 'UsersList' && <UsersList togglePage={switchActivePage} fetchMyAPI={fetchMyAPI} apiData={promoUsersList} tableData={tableData} updateUsersPromoCodeList={updateUsersPromoCodeList} updateUsersPromoCodeTableData={updateUsersPromoCodeTableData} updatePromoCodeStatus={updatePromoCodeStatus} updateNewPromoCodeListforUserFromUsersListPage={updateNewPromoCodeListforUserFromUsersListPage} />}
                    {activePage === 'UsersPromoCodeList' && <UsersPromoCodeList togglePage={switchActivePage} fetchMyAPI={fetchMyAPI} apiData={usersPromoCodeList} promoUsersTableData={promoUsersTableData} />}
                    {activePage === 'AddPromoCodeforUser' && <AddPromoCodeforUser togglePage={switchActivePage} fetchMyAPI={fetchMyAPI} promoCodeList={dataList} updateNewPromoCodeListforUser={updateNewPromoCodeListforUser} />}

                    {activePage === 'UsersListCheckoutPromo' && <UserListCheckoutPromo togglePage={switchActivePage} apiData={promoUsersListCheckout} tableData={tableDataCheckout} />}

                    <AlertModal
                        isOpen={modal}
                        toggle={toggleModal}
                        title=''
                        content={modalContent}
                    />

                    <Modal isOpen={deleteConfirmationModal} centered={true}>
                        <ModalHeader toggle={e => {
                            setDeleteConfirmationModal(!deleteConfirmationModal)
                            localStorage.removeItem('promoDeleteIndex')
                        }}>
                            Delete Confirmation
                        </ModalHeader>
                        <ModalBody>
                            Are you sure you want to delete this promo code?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="success" onClick={handleDeleteConfirmation}>Yes</Button>
                            <Button color="secondary" onClick={e => {
                                setDeleteConfirmationModal(!deleteConfirmationModal)
                                localStorage.removeItem('promoDeleteIndex')
                            }}>
                                No
                            </Button>
                        </ModalFooter>
                    </Modal>
                </>

                :

                <p>You are not authorized to view this page.</p>
            }
        </>

    )
};

export default PromoCode;

const RightSection = styled.div`
        display: grid;
        grid-auto-flow: column;
        gap: 10px;
        @media(max-width:500px) {
            display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        > div:first-child{
            max-width: 100%;
        }
        button{
            float: left;
        }
    }           
`